import {Component, Input, OnInit} from '@angular/core';
import {VerificaPfResponseDTO} from '../../models/estremi-persona-fisica.model';

@Component({
  selector: 'lib-dati-residenza',
  templateUrl: './dati-residenza.component.html',
  styleUrls: ['./dati-residenza.component.css']
})
export class DatiResidenzaComponent implements OnInit {

	@Input()
	validateAndGetResidenza: VerificaPfResponseDTO;

  constructor() { }

  ngOnInit(): void {
  }

}
